export default {
  QUIT: 'Quit',
  MANAGEMENT: 'Management',
  ATTENDANCE: 'Attendance',
  NEW_EMPLOYMENT: 'New employment',
  DISSATISFACTION: 'Dissatisfaction',
  INSOBURDINATION: 'Insubordination',
  JOB_ABANDONMENT: 'Job abandonment',
  PERSONAL_REASON: 'Personal reason',
  WORK_PERFORMANCE: 'Work performance',
  RECORD_FALSIFICATION: 'Record falsification',
  COMPANY_POLICY_VIOLATION: 'Company policy violation',
  OTHER: 'Other',
  ACCIDENT: 'Accident',
  UNKNOWN: 'Unknown'
}


// WEBPACK FOOTER //
// ./src/utils/termination-reason.ts